import { PermissionsView } from '@app/modules/admin/components/permission/view/PermissionsView';
import { GroupStationPermissionItem } from '@app/modules/admin/components/stations-permissions/GroupStationPermissionItem';
import { GroupPermissionForStationState } from '@app/modules/admin/types';
import { Group } from '@mi-front/core';
import { NullState } from '@mi-front/ui';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGroupPermissionsForAllQuery } from '../../hooks/useGroupPermissionsForAllQuery';

export const GroupPermissionsManager = (p: { group: Group }) => {
  const { $t } = useIntl();
  const query = useGroupPermissionsForAllQuery(p.group.id);

  return (
    <QueryView query={query}>
      {(permissionsState) => (
        <PermissionsView
          permissionsState={permissionsState}
          canModify={() => true}
          filterFn={(pState, text) => {
            return !!pState.station.name.match(new RegExp(text, 'i'));
          }}
          emptyListMsg={
            <NullState>
              <FormattedMessage
                id="admin.groups.viewScreen.permissions.noFilterMatch"
                defaultMessage="No se encontraron emisoras coincidentes"
              />
            </NullState>
          }
          filterPlaceholder={$t({
            id: 'admin.groups.viewScreen.permissions.filterPlaceholder',
            defaultMessage: 'Filtrar emisoras',
          })}
          PermissionItemComponent={({
            permissionState,
          }: {
            permissionState: GroupPermissionForStationState;
          }) => <GroupStationPermissionItem permissionState={permissionState} group={p.group} />}
        />
      )}
    </QueryView>
  );
};
